















































































import VueOptions from '@utils/VueOptions'
import VenueFields from '@ui/FormBuilder/ResourceFields/VenueFields.coffee'
import FormField from '@ui/FormBuilder/FormField'
import PersonaTimeWindowsTriggerModal from '@triggers/AudienceAvailability/PersonaTimeWindowsTriggerModal'

settings =
  name: 'VenueLocationForm'

  resources:
    venues:
      resourceName: 'venues'
      slug: ':venuesSlug'
      fetch: false
    venue:
      resourceName: 'venue'
      slug: ':venuesSlug/:form.data.id'
      fetch: false
    organizers:
      resourceName: 'organizers'
      slug: 'suppliers/:wizard.supplierId/organizers'
      fetch: false
      params:
        limit: 1000

  vue:
    props: ['wizard', 'form', 'actions']

    components: {
      FormField,
      PersonaTimeWindowsTriggerModal,
    }

    data: ->
      newRecapContact:
        first_name: null
        last_name: null
        email: null
        phone: null
      selectedRecapContact: null
      recapContactCollapse: ['select']

    computed:
      audienceCreativeId: ->
        @$route.params.audienceCreativeId

      venuesSlug: ->
        slug = "suppliers/#{@wizard.supplierId}/audience_creatives/#{@audienceCreativeId}/venues" if @audienceCreativeId
        slug ||= "suppliers/#{@wizard.supplierId}/venues"
        slug

      venueClass: ->
        @form?.data?.venue_class

      venueNameLabel: ->
        return 'Region Name' if @venueClass is 'regional'
        'Venue Name'

      isSaved: ->
        !!@form?.data?.id

      hasAvailabilities: ->
        !!@form?.data?.ctx?.availabilities?.length

      hasMissingPastDates: ->
        !!@form?.data?.ctx?.missing_persona_dates

      locationKeys: ->
        [
          'venue_class'
          'venue_name'

          # venue
          'timezone'
          'street'
          'city'
          'state'
          'zip'
          'country'
          'geo_coordinates'
          'geo_polygons'
          'geo_fenced'
          'geo_fence_trusted'

          # regional
          'regional_locations'
        ]

      locationErrors: ->
        @form.errors[key] for key in @locationKeys when @form.errors[key]

      fieldKeys: ->
        [
          'venue_type'
          'venue_setting'
          'storage_facilities_available'
          'physical_signs'
          'max_pallet_count'
        ]

      formFields: ->
        fields = {}
        fields[key] = @venueFields.fields[key] for key in @fieldKeys
        fields

      contextForVenueFields: ->
        options:
          venue_type: @toSelectOptions(@$store.marketplace?.listing?.venue_types)
          primary_team: @toSelectOptions(@$store.marketplace?.brand?.categories)

      inputPropsForVenueLocation: ->
        nationalVenues: @venues
        supplierId: @wizard.supplierId
        audienceCreativeId: @audienceCreativeId

      venueFields: ->
        VenueFields(@contextForVenueFields)

      optionsForPersonaTimeWindowsModal: ->
        supplierId: @wizard.supplierId
        audienceCreativeId: @audienceCreativeId
        venueId: @form.data.id

      availableRecapContacts: ->
        emails = @pluck @form.data.contacts.recap || [], 'email'
        list = @organizers || []
        list.filter((item) => item.email not in emails)

    mounted: ->
      @fetch 'venues' if @venueClass is 'national'
      @fetch 'organizers'

    methods:
      hiLocationChange: (venue) ->
        venue.venue_name ||= 'Nationwide' if venue.venue_class is 'national'
        @forceFormDataReactivity venue
        @saveField @locationKeys

      hiSetTimeWindow: ->
        @$refs.personaTimeWindowsTriggerModal.open()

      hiTabSelectRecapContact: ->
        @recapContactCollapse = ['select']
      hiTabCreateRecapContact: ->
        @recapContactCollapse = ['create']

      hiSelectRecapContact: (email) ->
        @triggerResource 'venue', 'add_recap_contact', { email }
      hiCreateRecapContact: ->
        @triggerResource 'venue', 'add_recap_contact', @newRecapContact
      onVenueAddRecapContact: (payload, venue) ->
        @selectedRecapContact = null
        @newRecapContact[key] = null for key of @newRecapContact
        @forceFormDataReactivity venue

      hiRemoveRecapContact: (email) ->
        @triggerResource 'venue', 'remove_recap_contact', { email }
      onVenueRemoveRecapContact: (payload, venue) ->
        @forceFormDataReactivity venue

      forceFormDataReactivity: (venue) ->
        @form.data[key] = value for key, value of venue

      saveField: (fieldName) ->
        if @actions?.saveField?
          @actions.saveField fieldName
        else
          @wizard.saveField fieldName

    watch:
      venueClass: (venueClass) ->
        @fetch 'venues' if venueClass is 'national'

export default VueOptions.vue settings
